module.exports = __webpack_public_path__ + "static/media/38.44912b64.wav";